import { FC } from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

interface Props {
  isAppPopup?: boolean;
}

export const IngredientNoticeView: FC<React.PropsWithChildren<Props>> = ({ isAppPopup = false }) => {
  return (
    <Root isAppPopup={isAppPopup}>
      <Title className={Typography.HEAD_20_BOLD}>성분 정보 유의 사항</Title>
      <Contents>
        <NoticeText className={Typography.BODY_15_REGULAR}>
          성분 정보는 판매업자가 작성한 전 성분 표기에 기초하여 작성되었으며, 판매업자가 표준화된 성분명으로 기재하지
          않은 등 특이사항이 있는 경우 일부 성분에 대한 정보가 제공되지 않습니다. <br />
          식품의약품안전처고시 규정에 따른 알레르기 유발성분, 기능성 화장품 정보와 개별 성분의 주된 배합 목적을 매칭하여
          제공하고 있으며 성분간의 배합, 개인의 피부와 사용 환경 등에 따라 제품의 효능, 효과는 변경될 수 있습니다.
        </NoticeText>
      </Contents>
    </Root>
  );
};

const Root = styled.section<{ isAppPopup?: boolean }>`
  padding-top: 2px;
  ${({ isAppPopup }) => !isAppPopup && 'margin: 40px 16px 30px;'}
`;

const Title = styled.p`
  display: flex;
  align-items: center;
`;

const Contents = styled.div`
  padding: 10px 0 16px;
`;

const NoticeText = styled.p`
  line-height: 160%;
  color: ${vars.v3Color.gray600};
`;
